<template>
    <div>
        <div v-if="master_installation.id">
            <b-row>
                <b-col sm="5">
                    <installation-code-input :installation-code="master_installation.installation_code"
                                             :validation="validation_master_installation.installation_code"
                                             :prev-id="prevId"
                                             :next-id="nextId"
                                             @update="handleUpdateFields"
                                             @navigate="navigate"/>
                </b-col>
                <b-col sm="5">
                    <client-input :client="master_installation.client"
                                  :validation="validation_master_installation.client"
                                  @update="handleUpdateFields"></client-input>
                </b-col>
                <b-col sm="2">
                    <b-button v-if="edit && can('edit_vhe_children') && activeTab === 0" variant="outline-success" block class="mt-2" @click="updateInstallation()" >
                      Guardar
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <div v-if="!master_installation.id">
            <b-row sm="12">
                <b-col sm="3">
                    <typology-id-select :typology-id="master_installation.typology_id"
                                        :show-description="true"
                                        @update="handleUpdateFields"/>
                </b-col>
                <b-col sm="3">
                    Código PRVE
                    <b-form-group>
                        <b-form-input v-model="master_installation.vhe_code" autocomplete="off"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="2">
                    <date-start-flat-pickr :date-start="master_installation.start_date"
                                           :validation="validation_master_installation.start_date"
                                           @update="handleUpdateFields"/>
                </b-col>
                <b-col sm="2">
                    <date-end-flat-pickr :date-end="master_installation.end_date"
                                         :validation="validation_master_installation.end_date"
                                         @update="handleUpdateFields"/>
                </b-col>
                <b-col sm="2" class="align-content-center" v-if="!edit">
                  <b-button variant="outline-success" block @click="createInstallation()">
                    Crear
                  </b-button>
                </b-col>
            </b-row>
            <hr class="mb-2">

        </div>
    </div>
</template>
<script>
import {BCol, BRow, BButton, BFormInput, BFormGroup} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import installationCodeInput from "@/views/vhe/masters_installations/form/formHeader/components/installationCodeInput"
import installationCodeConcatInput from "@/views/vhe/masters_installations/form/formHeader/components/installationCodeConcatInput"
import clientInput from "@/views/vhe/masters_installations/form/formInstallationData/components/clientInput"
import typologyIdSelect from "@/views/vhe/masters_installations/form/formInstallationData/components/typologyIdSelect"
import DateStartFlatPickr
    from "@/views/vhe/masters_installations/form/formInstallationData/components/dateStartFlatPickr.vue"
import DateEndFlatPickr
    from "@/views/vhe/masters_installations/form/formInstallationData/components/dateEndFlatPickr.vue"

import {VHE_MASTERS_INSTALLATIONS_LIST} from "@/router/web/constants"

const {mapFields} = createHelpers({
    getterType: 'masterInstallationVhe/getField',
    mutationType: 'masterInstallationVhe/updateField',
})

export default {
    components: {
        DateEndFlatPickr,
        DateStartFlatPickr,
        clientInput,
        typologyIdSelect,
        installationCodeInput,
        //installationCodeConcatInput,
        // segmentIdSelect,

        BCol,
        BRow,
        BButton,
        BFormInput,
        BFormGroup
    },
    props: {
      activeTab: {
        type: Number,
        required: true,
      },
      prevId: {
        type: Number,
        default: null,
      },
      nextId: {
        type: Number,
        default: null,
      },
    },
    data() {
        return {
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('masterInstallationVhe', ['validation_master_installation']),
        ...mapFields({
            master_installation: 'master_installation',
        }),
    },

    mounted() {
        if (this.$route.params.id) {
            this.edit = true
        } else {
            this.edit = false
        }
    },

    methods: {
        navigate(id) {
            if (id) {
                this.$router.push({ name: 'installations_vhe_edit', params: { id } })
            }
        },
        handleUpdateFields(updatedFields) {
            this.master_installation = {...this.master_installation, ...updatedFields}
        },
        createInstallation() {
            this.$root.$refs.masterInstallationForm.createInstallation()
            this.$router.replace(VHE_MASTERS_INSTALLATIONS_LIST)
        },
        updateInstallation() {
            this.$root.$refs.masterInstallationForm.updateInstallation()
        },
        can(permission) {
            return this.$store.getters.can(permission)
        },
    },

}
</script>